/* eslint-disable @typescript-eslint/no-explicit-any */
import { SharedAppConstants } from '@tock/shared-app-constants';
import { safeToNumber } from '@tock/coretypes';

export enum LoadingState {
  NOT_LOADING = 'NOT_LOADING',
  LOADING = 'LOADING',
  LOADED = 'LOADED',
}

export interface MetricValues {
  allBookings: number;
  allCancellations: number;
  allNoShows: number;
  allWalkIns: number;
  bookByEmail: number;
}

interface State {
  loadingState: LoadingState;
  statsValues?: MetricValues;
  waitlistStatsValue: any;
  patronStatsById: { [id: string]: { loadingState: LoadingState; statsValues?: MetricValues } };
}

const initialState: State = {
  loadingState: LoadingState.NOT_LOADING,
  statsValues: undefined,
  waitlistStatsValue: null,
  patronStatsById: {
    // Example state
    [`${'patronId'}-${'businessId'}`]: {
      loadingState: LoadingState.NOT_LOADING,
      statsValues: undefined,
    },
  },
};

export function getKeyForPatronAndBusiness(patronId: number, businessId: number) {
  return `${patronId}-${businessId}`;
}

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { context, type } = action;
  switch (type) {
    case SharedAppConstants.PATRON_STATS_FETCH_STARTING:
    case SharedAppConstants.PATRON_WAITLIST_STATS_FETCH_STARTING:
      if (context) {
        return updateStateForContext(state, context, {
          loadingState: LoadingState.LOADING,
        });
      }
      return {
        ...state,
        loadingState: LoadingState.LOADING,
      };
    case SharedAppConstants.PATRON_STATS_FETCH_DONE: {
      const responses = action.payload;
      const datapoint = responses.response[0].datapoint[0];
      const metricValues = {
        allBookings: safeToNumber(datapoint.metricValue[0].value),
        allNoShows: safeToNumber(datapoint.metricValue[1].value),
        allCancellations: safeToNumber(datapoint.metricValue[2].value),
        bookByEmail: safeToNumber(datapoint.metricValue[3].value),
        allWalkIns:
          safeToNumber(datapoint.metricValue[4].value) +
          safeToNumber(datapoint.metricValue[5].value),
      };
      if (context) {
        return updateStateForContext(state, context, {
          loadingState: LoadingState.LOADED,
          statsValues: metricValues,
        });
      }
      return {
        ...state,
        loadingState: LoadingState.LOADED,
        statsValues: metricValues,
      };
    }
    case SharedAppConstants.PATRON_WAITLIST_STATS_FETCH_DONE:
      return {
        ...state,
        loadingState: LoadingState.LOADED,
        waitlistStatsValue: action.payload.length,
      };
    case SharedAppConstants.PATRON_STATS_FETCH_FAILED:
    case SharedAppConstants.PATRON_WAITLIST_STATS_FETCH_FAILED:
      if (context) {
        return updateStateForContext(state, context, {
          loadingState: LoadingState.NOT_LOADING,
        });
      }
      return {
        ...state,
        loadingState: LoadingState.NOT_LOADING,
      };
    default:
      return state;
  }
}

function updateStateForContext(state: State, context: any, stateForContext: any) {
  return {
    ...state,
    patronStatsById: {
      ...state.patronStatsById,
      [getKeyForPatronAndBusiness(context.patronId, context.businessId)]: {
        ...stateForContext,
      },
    },
  };
}
